import {
    getNotifications,
    readNotifications,
    clearAllNotifications,
} from '../../../services/NotificationService';
import {
    CONFIRMED_GET_NOTIFICATIONS,
    CLEAR_ALL_NOTIFICATIONS,
} from './NotificationTypes';



export function getNotificationsAction(currentPage, pageSize) {
    return (dispatch, getState) => {
        getNotifications(currentPage, pageSize).then((response) => {
            dispatch(confirmedGetNotificationsAction(response.data.data));
        });
    };
}

export function confirmedGetNotificationsAction(data) {
    return {
        type: CONFIRMED_GET_NOTIFICATIONS,
        payload: data,
    };
}

export function readNotificationsAction(notifications) {
    return (dispatch, getState) => {
        return readNotifications(notifications).then((response) => {
            // Optionally dispatch an action here if you want to update state
            return response;
        });
    };
}

export function clearAllNotificationsAction() {
    return (dispatch, getState) => {
        return clearAllNotifications().then((response) => {
            if (response.data.success) {
                // Clear notifications in state after successful API call
                dispatch({
                    type: CLEAR_ALL_NOTIFICATIONS,
                    payload: { rows: [], pages: 1, unreadCount: 0, total: 0 }
                });
            }
            return response;
        });
    };
}



